var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"content--wrap content-box",class:{type2: _vm.isDimmedContent},style:({ width: `${_vm.width}`, height: `${_vm.height}`, minWidth: `${_vm.minWidth}`, minHeight: `${_vm.minHeight}` })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }